export function isAlreadyOnMaintenancePage(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const { pathname } = window.location;
  return pathname === '/maintenance' || pathname.startsWith('/maintenance/');
}
